const StationStatusEnum = {
  PENDING: "pending",
  ACTIVE: "active",
  DEACTIVATED: "deactivated",
  MANUAL_MODE: "manual-mode",
};

export default StationStatusEnum;
